import { MessageSquareText, Star } from "lucide-react";

interface EmptyReviewsProps {
  onLeaveReview?: () => void;
}

export default function EmptyReviews({ onLeaveReview }: EmptyReviewsProps) {
  return (
    <div className="rounded-3xl border bg-card py-20 px-8 text-center shadow-sm">
      <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-muted">
        <MessageSquareText className="h-10 w-10 text-muted-foreground" />
      </div>

      <h2 className="mt-6 text-2xl font-bold">No Reviews Yet</h2>

      <p className="mx-auto mt-3 max-w-md text-muted-foreground leading-7">
        This merchant hasn't received any reviews yet for this type. Be the
        first trader to share your experience after a completed transaction.
      </p>

      {/* <div className="mt-8 flex justify-center">
        <Button onClick={onLeaveReview}>
          <Star className="mr-2 h-4 w-4" />
          Write the First Review
        </Button>
      </div> */}
    </div>
  );
}
